import { Injectable } from '@angular/core';
import { ResourceIdentifier } from '@talisdev/jsonapi-transformers';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { TarlV3Jsonapi } from '®shared/tarl-v3-jsonapi';

import { RoleRecord } from './role-record';
import { UserConstraint } from './user-constraint';
import { UserRecord } from './user-record';

export type UserRecordsResults = {
  total: number;
  users: UserRecord[];
};

@Injectable()
export class UserService {
  constructor(private tarlV3Jsonapi: TarlV3Jsonapi) {}

  assignRoleToUser(
    role: RoleRecord,
    user: UserRecord,
    appliesTo: ResourceIdentifier,
  ): Observable<UserConstraint> {
    const path = this.tarlV3Jsonapi.path('/user_constraints', {});

    const userConstraint = new UserConstraint();

    userConstraint.role = role;
    userConstraint.user = user;
    userConstraint.applies_to = appliesTo;

    return this.tarlV3Jsonapi.postResource(path, userConstraint);
  }

  searchUsers(
    searchTerm: string,
    limit: number,
  ): Observable<UserRecordsResults> {
    const params = { searchTerm, limit };
    return this.tarlV3Jsonapi
      .getPageOfResources<UserRecord>('/users', params)
      .pipe(
        map(pageOfUserRecords => {
          const {
            data: users,
            meta: { total },
          } = pageOfUserRecords;
          return { users, total };
        }),
      );
  }

  loginWithTarl(userId: string, activePid: string): Observable<UserRecord> {
    const path = this.tarlV3Jsonapi.path('/login', {});
    const userRecord = new UserRecord();
    userRecord.id = userId;
    userRecord.active_pid = activePid;

    return this.tarlV3Jsonapi.postResource(path, userRecord);
  }

  updateUserProfile(user: UserRecord): Observable<UserRecord> {
    const path = this.tarlV3Jsonapi.path('/users/{userGuid}', {
      userGuid: user.id,
    });

    return this.tarlV3Jsonapi.patchResource(path, user);
  }
}
